﻿"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StateRatesArea = void 0;
const com = require("../../com/tmpls");
const modalCom = require("@ivanlog/gs-com-modal_dialogs");
const L = require("leaflet");
const StatePaged_1 = require("../abstracts/StatePaged");
const models_1 = require("../../api/admin/classes/models");
const gs_1 = require("@ivanlog/gs");
const AccessTypeEnum_1 = require("../../enums/AccessTypeEnum");
const StateRatesAreas_1 = require("./StateRatesAreas");
class StateRatesArea extends StatePaged_1.StatePaged {
    constructor() {
        super(com.PageRatesArea, "Rates area", true);
        this._points = [];
        this.page.ctrls.btnSave.onclick = () => this.trySave();
        this.page.ctrls.btnSave.hide();
        if (this.app.auth.hasAccess(AccessTypeEnum_1.AccessTypeEnum.RateControl)) {
            this.page.ctrls.btnSave.show();
            this.page.ctrls.btnClear.onclick = () => this._resetPoints();
        }
    }
    start(args) {
        const _super = Object.create(null, {
            start: { get: () => super.start }
        });
        return __awaiter(this, void 0, void 0, function* () {
            if (args) {
                if (args instanceof models_1.RateArea)
                    this._area = args;
                else if (args.id) {
                    this._area = yield this.app.astra.getRateArea(args.id);
                    if (!this._area)
                        return gs_1.StateRunResultEnum.Failed;
                }
            }
            if (this._area)
                this._urlArgs["id"] = this._area.id.toString();
            yield this.fill();
            return _super.start.call(this);
        });
    }
    fill() {
        return __awaiter(this, void 0, void 0, function* () {
            var ctrl = this.page.ctrls;
            if (this._area) {
                this.page.ctrls.btnClear.hide();
                this.page.ctrls.btnSave.hide();
                yield ctrl.form.fillFormData(this._area, true);
                ctrl.iName.addClass('no-active');
            }
        });
    }
    afterStart() {
        const _super = Object.create(null, {
            afterStart: { get: () => super.afterStart }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.afterStart.call(this);
            if (this._area)
                this.setLabel(this.title + ` #${this._area.id}`);
            this._initMap();
        });
    }
    _initMap() {
        this._map = L.map('map').setView([48.142723, 11.576843], 10);
        var tiles = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
            maxZoom: 19,
            attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
        }).addTo(this._map);
        if (this._area) {
            this._points = [];
            for (const c of this._area.polygon)
                this._points.push(new L.LatLng(c.lat, c.lng));
            this._polygon = L.polygon(this._points).addTo(this._map);
        }
        else {
            this._map.on('click', (ev) => {
                let e = ev;
                this._points.push(e.latlng);
                this._polygon.addLatLng(e.latlng);
            });
            this._resetPoints();
        }
    }
    _resetPoints() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this._polygon)
                this._polygon.removeFrom(this._map);
            this._polygon = L.polygon([]).addTo(this._map);
            this._points = [];
        });
    }
    trySave() {
        return __awaiter(this, void 0, void 0, function* () {
            var data = yield this.page.ctrls.form.getFormData();
            if (!data)
                return;
            let area;
            const req = new models_1.CreateRateAreaRequest(data);
            req.coordinates = [];
            for (const p of this._points)
                req.coordinates.push(new models_1.Coordinates(p));
            area = yield this.lockgui(this.app.api.admin.directory.createRateArea(req));
            if (!area)
                return;
            yield new modalCom.DialogOk("Rate area created").show();
            yield gs_1.StateGS.Run(StateRatesAreas_1.StateRatesAreas);
        });
    }
}
exports.StateRatesArea = StateRatesArea;
StateRatesArea.StateName = "ratesArea";
//# sourceMappingURL=StateRatesArea.js.map